import { TimeSelectorActions } from "./TimeSelector.actions";
import { initialState } from "../initialState";
import { TimeSelectorState } from "models";
import { makeMillLocalTime } from "utils/time.utils";
import { addMinutes } from "date-fns";

export const timeSelectorReducer = (
  state: TimeSelectorState = initialState.timeSelector,
  action: { type: string; payload: { newDate: Date; offset: number } | number },
): TimeSelectorState => {
  switch (action.type) {
    case TimeSelectorActions.SetStartTime:
      const { newDate, offset } = action.payload as { newDate: Date; offset: number };

      const endTime = addMinutes(newDate, 10).toISOString();

      return {
        ...state,
        startTime: newDate.toISOString(),
        endTime,
        localMillTime: makeMillLocalTime(newDate, offset).toISOString(),
      };

    case TimeSelectorActions.SetMillLocalTime:
      const millUTCOffset = action.payload as number;
      const localMillTime = makeMillLocalTime(newDate, millUTCOffset).toISOString();

      return {
        ...state,
        localMillTime,
      };

    default:
      return state;
  }
};
